var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.023,
    height: 25,
    viewBox: "0 0 16.813 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.525,
    y1: 0.5,
    x2: 1.58,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06bcc1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Filter_-_Icon",
    "data-name": "Filter - Icon",
    d: "M5855.2,7465a2.008,2.008,0,0,1-1.823-1.18H5849v-1h4.21A1.992,1.992,0,0,1,5855.2,7461a2.015,2.015,0,0,1,1.992,1.827h8.618v1h-8.787A2.007,2.007,0,0,1,5855.2,7465Zm0-3.007a.883.883,0,0,0-.1,0,1,1,0,0,0,0,2,.933.933,0,0,0,.095,0,.989.989,0,0,0,.566-.18h-.047a1,1,0,0,0,.418-1h.047A1,1,0,0,0,5855.2,7461.995Zm5.952-2a2,2,0,0,1-1.823-1.173H5849v-1h10.162a2,2,0,0,1,3.985,0h2.666v1h-2.834A2.007,2.007,0,0,1,5861.155,7460Zm-.071-1a.136.136,0,0,0,.028,0h.086a.138.138,0,0,0,.028,0,.176.176,0,0,0,.037,0h.02l.017,0h.007l.026,0,.006,0c.005,0,.008,0,.009,0l.013,0h.011l.011,0a.1.1,0,0,1,.026-.008h.006l.007,0,.007,0,.01,0,.028-.009.009,0,.009,0,.009,0,.007,0a1.115,1.115,0,0,0,.218-.11,1,1,0,0,0-.1-1.71l-.007,0-.012-.006-.009-.005-.01,0-.015-.007-.006,0-.009,0-.009,0a.476.476,0,0,0-.059-.022l-.006,0-.015,0-.008,0h0l-.009,0-.007,0h-.006a.033.033,0,0,0-.013,0h-.009a.023.023,0,0,0-.013,0l-.01,0h0l-.008,0-.013,0-.01,0-.009,0-.011,0-.011,0h-.013l-.009,0h-.007l-.008,0h-.009l-.007,0-.008,0h-.211l-.01,0-.011,0a1,1,0,0,0-.82.669l-.005.011,0,.007a1,1,0,0,0,.39,1.13h0a.994.994,0,0,0,.362.151l.005,0,.009,0,.011,0,.008,0h.007l.021,0,.022,0h.011l.019,0,.013,0ZM5853.2,7455a2,2,0,0,1-1.821-1.182H5849v-1h2.211A1.987,1.987,0,0,1,5853.2,7451a2.01,2.01,0,0,1,1.994,1.819h10.617v1h-10.786A2,2,0,0,1,5853.2,7455Zm-.019-1h0l.009,0h.009a.971.971,0,0,0,.566-.182h-.043a1,1,0,0,0,.429-.819.826.826,0,0,0-.015-.18h.048a.993.993,0,0,0-.968-.819.343.343,0,0,0-.064-.006,1,1,0,0,0,0,2h.015l.013,0Z",
    transform: "translate(-5849 -7451.001)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.6f69c49b8ad89d5edf8369e999689e69.svg";
export { ForwardRef as ReactComponent };